import { Box } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { Controller } from "react-hook-form"
import styled from "styled-components"

import { InputWrapper, SectionTitle, Text } from "areas/order/components"
import FloatSelect from "components/ui/float-select"
import Textarea from "components/ui/textarea"

const ReasonTitle = styled(SectionTitle)`
  text-transform: capitalize;
`

const repairReasons = [
  ["Stone has fallen out or is loose", "Stone Fell Out"],
  ["Stone quality", "Stone quality"],
  ["Incorrect stone was ordered or sent, change stones", "Stone wrong"],
  ["Stones are too small", "Stone size"],
  ["Engraving is incorrect, add or change engravings", "Engravings wrong"],
  ["Engraving is hard to read", "Engravings hard to read"],
  ["Chain is broken", "Chain broken"],
  ["Chain length is too short/long", "Chain size"],
  ["Silver tarnished", "Tarnished"],
  ["Other (Please specify details)", "Other"],
]

const returnReasons = [
  ["Request a ring resize", "Ring resize"],
  ["Stone has fallen out or is loose", "Stone Fell Out"],
  ["Stone quality", "Stone quality"],
  ["Incorrect stone was ordered", "Stones wrong"],
  ["Stones are too small", "Stone size"],
  ["Engraving is incorrect", "Engravings wrong"],
  ["Engraving is hard to read", "Engravings hard to read"],
  ["Chain is broken", "Chain broken"],
  ["Chain length is too short/long", "Chain size"],
  ["Silver tarnished", "Tarnished"],
  ["Overall item size", "Overall size"],
  ["Item is no longer needed", "Item not needed"],
  ["Other (Please specify details)", "Other"],
]

const Reason = ({ control, formType, items, line_items = [] }) => {
  let reasons = formType == "return" ? returnReasons : repairReasons

  const selectedLineItems = line_items.filter((li) => items.includes(li.id))
  const hasStones = selectedLineItems.some((li) => li.has_stones)

  const filteredReasons = reasons.filter((reason) => {
    if (!hasStones) {
      if (Array.isArray(reason)) {
        const r = reason[0].toLowerCase()
        return !r.includes("stone")
      }
      return !reason.toLowerCase().includes("stone")
    } else {
      return reason
    }
  })

  return (
    <Box flex="1" pt={2}>
      <ReasonTitle>Reason For The {formType}</ReasonTitle>
      <Text mb={2}>Please enter your reason for the {formType} below:</Text>
      <InputWrapper>
        <Controller
          control={control}
          name="rma_reason"
          render={({ field, fieldState: { error } }) => (
            <FloatSelect
              error={error}
              id="rma_reason"
              label="Select A Reason"
              {...field}
            >
              <option value="">Select A Reason</option>
              {filteredReasons.map((reason, i) => (
                <option key={i} value={reason[1]}>
                  {reason[0]}
                </option>
              ))}
            </FloatSelect>
          )}
        />
      </InputWrapper>
      <InputWrapper>
        <Controller
          control={control}
          name="notes"
          render={({ field, fieldState: { error } }) => (
            <Box width="100%">
              <Textarea
                error={error}
                id="notes"
                placeholder="Enter the details regarding your request"
                rows="4"
                variant="checkout"
                {...field}
              />
            </Box>
          )}
        />
      </InputWrapper>
    </Box>
  )
}

Reason.propTypes = {
  control: PropTypes.object,
  formType: PropTypes.string,
  items: PropTypes.array,
  line_items: PropTypes.array,
}

export default Reason
